import { Button, Card, Col, Container, Row } from "react-bootstrap";

import { FaShoppingCart } from "react-icons/fa";

import "./sellerCardStyles.css";

const SellerCard = ({ image, buttonLabel, buttonColor, onPressButton }) => (
  <Card className="seller-card">
    <Card.Header className="seller-card-header p-0">
      <img src={image} className="img-fluid" alt="seller-img" />
    </Card.Header>
    <Card.Body className="seller-card-body px-0">
      <Button className={`${buttonColor} py-2`} onClick={onPressButton}>
        <Container>
          <Row>
            <Col xs={1}>
              <FaShoppingCart />
            </Col>
            <Col>
              <span>{buttonLabel}</span>
            </Col>
          </Row>
        </Container>
      </Button>
    </Card.Body>
  </Card>
);

export default SellerCard;
